import { setUrlParam } from '../../helpers/url_helper';
import { propertyIdOffMarketPropertySearch } from 'bundles/connect/helpers/connect_api';

export const SET_HOVER_LISTING_ID = 'SET_HOVER_LISTING_ID';
export const SET_OFF_MARKET_HOVER_PROPERTY_ID = 'SET_OFF_MARKET_HOVER_PROPERTY_ID';
export const SET_LISTING_ID = 'SET_LISTING_ID';
export const SET_OFF_MARKET_PROPERTY_ID = 'SET_OFF_MARKET_PROPERTY_ID';
export const SET_LOADING = 'SET_LOADING';
export const SET_SHOW_MAP = 'SET_SHOW_MAP';
export const SET_SAVE_SEARCH_MODAL = 'SET_SAVE_SEARCH_MODAL';
export const INCREMENT_LISTING_VIEW_COUNT = 'INCREMENT_LISTING_VIEW_COUNT';
export const SET_OFF_MARKET_SEARCH = 'SET_OFF_MARKET_SEARCH';
export const SET_MAP_LOADED = 'SET_MAP_LOADED';
export const SET_MAP_ZOOM_READONLY = 'SET_MAP_ZOOM_READONLY';
const MODAL_PROMPT_VIEW_COUNT = 5;

export function mapLoaded() {
  return { type: SET_MAP_LOADED };
}

export function setOffMarketSearch(val) {
  return {
    type: SET_OFF_MARKET_SEARCH,
    payload: val
  };
}

export function setMapZoomReadonly(val) {
  return {
    type: SET_MAP_ZOOM_READONLY,
    payload: val
  };
}

export function setHoverListingId(id) {
  return {
    type: SET_HOVER_LISTING_ID,
    payload: id
  };
}

export function setOffMarketHoverPropertyId(id) {
  return {
    type: SET_OFF_MARKET_HOVER_PROPERTY_ID,
    payload: id
  };
}

export function setListingId(id) {
  setUrlParam('exclusive_listing_id', id);

  return (dispatch, getState) => {
    const { ui, criteria } = getState();
    if (id) {
      dispatch({ type: INCREMENT_LISTING_VIEW_COUNT });
    } else if (ui.listingViewCount >= MODAL_PROMPT_VIEW_COUNT && criteria.assetClassIds && !ui.profileSavedSearch) {
      dispatch({ type: SET_SAVE_SEARCH_MODAL, payload: true });
    }

    dispatch({
      type: SET_LISTING_ID,
      payload: id
    });
  };
}

export function setOffMarketPropertyId(id) {
  setUrlParam('off_market_property_id', id);

  return {
    type: SET_OFF_MARKET_PROPERTY_ID,
    payload: id
  };
}

export function setLoading(loading) {
  return { type: SET_LOADING, payload: loading };
}

export function setShowMap(show) {
  return { type: SET_SHOW_MAP, payload: show };
}

export function showSaveSearchModal(show) {
  return { type: SET_SAVE_SEARCH_MODAL, payload: show };
}

// fullAddress is place name from google autocomplete, usually in the format of
// ADDRESS, CITY, STATE, COUNTRY
export function trySetPropertyFromAddress(fullAddress) {
  const [address, city, state] = fullAddress.split(',');

  return async (dispatch) => {
    propertyIdOffMarketPropertySearch(address, city, state)
      .then(({ id }) => dispatch(setOffMarketPropertyId(id)))
      .catch(() => {}); // No op on failed requests
  };
}
